// Shared helpers for global keyboard-shortcut handlers.

// True when a keydown originated from a field the user is actively typing in
// (an input, textarea, select, or contentEditable region). Global shortcuts
// should bail out in that case so they don't hijack normal typing.
export function isEditableShortcutTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    if (
        target.isContentEditable ||
        target.closest('[contenteditable="true"]')
    ) {
        return true;
    }
    return ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}
